var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7204 6.27748C15.0932 6.64745 15.0932 7.24729 14.7204 7.61726L10.3045 12L14.7204 16.3827C15.0932 16.7527 15.0932 17.3526 14.7204 17.7225C14.3476 18.0925 13.7433 18.0925 13.3705 17.7225L8.27958 12.6699C7.90681 12.2999 7.90681 11.7001 8.27958 11.3301L13.3705 6.27748C13.7433 5.90751 14.3476 5.90751 14.7204 6.27748Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.6e86c3000e63465f09054b0e8b7120cf.svg";
export { ForwardRef as ReactComponent };